// extracted by mini-css-extract-plugin
export default {"container":"styles_container__5pT59","title":"styles_title__66Xt5","content":"styles_content__ZQsL5","button":"styles_button__s00FD"};